import axios from "axios";
import { onGetCookie, onRemoveCookie, onSetCookie } from "@/utils/handleCookie";
import CONFIGS from "@/constants/env";
import { refreshToken } from "@/features/authentication/services/auth.services";

const baseUrl = CONFIGS.API;

const services = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const handleError = () => {
  const pathName = window.location.pathname;
  onRemoveCookie();
  localStorage.clear();
  if (!pathName.includes("/view")) {
    window.location.href = "/";
  }
};

services.interceptors.request.use((config) => {
  const dataCookie = onGetCookie();
  if (dataCookie) {
    config.headers["Authorization"] = `Bearer ${dataCookie.token.token}`;
  }

  return config;
});

services.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && axios.isAxiosError(error)) {
      if (error.status === 401 && !originalRequest.retry) {
        originalRequest._retry = true;
        const dataCookie = onGetCookie();
        if (!dataCookie) {
          handleError();
          return Promise.reject({
            status: 403,
            message: "Please login again.",
          });
        }

        try {
          const response = await refreshToken({
            refreshToken: dataCookie.refresh_token,
          });

          onSetCookie({
            token: response.token,
            refresh_token: response.refresh_token,
            created_from: response.data.created_from,
          });

          originalRequest.headers["Authorization"] =
            `Bearer ${response.token.token}`;

          return services(originalRequest);
        } catch {
          handleError();
          return Promise.reject(error.response.data);
        }
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  },
);

export default services;
